export interface Training {
  sunday: {
    [trainingType: string]: string;
  };
  monday: {
    [trainingType: string]: string;
  };
  tuesday: {
    [trainingType: string]: string;
  };
  wednesday: {
    [trainingType: string]: string;
  };
  thursday: {
    [trainingType: string]: string;
  };
  friday: {
    [trainingType: string]: string;
  };
  saturday: {
    [trainingType: string]: string;
  };
  objective?: string;
  observation?: string;
  teacher?: string;
  trainingDueDate?: number;
}

export const WEEK_DAYS = [
  {
    key: "sunday",
    label: "Dom",
    fullLabel: "Domingo",
  },
  {
    key: "monday",
    label: "Seg",
    fullLabel: "Segunda-feira",
  },
  {
    key: "tuesday",
    label: "Ter",
    fullLabel: "Terça-feira",
  },
  {
    key: "wednesday",
    label: "Qua",
    fullLabel: "Quarta-feira",
  },
  {
    key: "thursday",
    label: "Qui",
    fullLabel: "Quinta-feira",
  },
  {
    key: "friday",
    label: "Sex",
    fullLabel: "Sexta-feira",
  },
  {
    key: "saturday",
    label: "Sáb",
    fullLabel: "Sábado",
  },
];
export const CURRENT_WEEK_DAY = WEEK_DAYS[new Date().getDay()];

export const TRAINING_TYPES = [
  "Peitoral",
  "Dorsais (Costas)",
  "Ombros",
  "Bíceps",
  "Tríceps",
  "Quadríceps",
  "Posterior da coxa",
  "Glúteos",
  "Músculos Abdominais",
  "Músculos Lombares",
  "Panturrilhas",
  "Cardiorrespiratório",
];
